<template>
  <v-menu>
    <template #activator="{ on }">
      <v-icon :color="iconColor" :small="small" v-on="on" v-html="menuIcon" />
    </template>
    <slot></slot>
  </v-menu>
</template>

<script>
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscMenuContainer',

  props: {
    iconColor: {
      type: String,
      default: variables.gray600,
    },
    menuIcon: {
      type: String,
      default: 'more_vert',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
